import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store';
import VueI18n from 'vue-i18n';
import Axios from 'axios';
import VueMeta from 'vue-meta';
import VueMq from 'vue-mq';
import messages from './lang';
import ItsPlugin from './plugins/ItsPlugin';
//import Jarolit from './plugins/Jarolit';
import {Cnst} from './plugins/Cnst.js';
import 'bootstrap/dist/css/bootstrap.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome, faSearch, faShareAlt, faQuestion, faHandPointUp, faAngleLeft, faAngleRight, faComment, faFolderOpen,
    faPlus, faMinus, faBroom, faEye, faBook, faEdit, faUsers, faUsersSlash, faTrashAlt, faLock, faLockOpen,
    faLink, faUnlink, faThumbtack, faCircle, faDownload, faRedo, faMapMarker, faGlobe, faInfo, faGift,  faBalanceScale } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faTwitter, faInstagram, faVk, faOdnoklassniki, faPinterest, faRedditAlien, faTripadvisor }
    from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { BVModalPlugin, VBPopoverPlugin } from 'bootstrap-vue'
Vue.use(BVModalPlugin)
Vue.use(VBPopoverPlugin)

require('@/assets/css/custom.scss')
require('@/assets/css/itsmap.css')

import App from './App.vue'
import routes from './routes';

Vue.use(VueI18n);
Vue.use(VueMeta);
Vue.use(ItsPlugin);
//Vue.use(Jarolit);
Vue.use(Cnst);
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);

library.add(faHome, faSearch, faShareAlt, faQuestion, faHandPointUp, faAngleLeft, faAngleRight, faComment,
    faFolderOpen, faPlus, faMinus, faBroom, faEye, faBook, faEdit, faUsers, faUsersSlash, faTrashAlt, faLock,
    faLockOpen, faLink, faUnlink, faThumbtack, faCircle, faDownload, faRedo, faMapMarker,
    faFacebookF, faTwitter, faInstagram, faVk, faOdnoklassniki, faPinterest, faRedditAlien, faTripadvisor, faGlobe, faInfo, faGift, faBalanceScale);

//dom.watch();

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

export const i18n = new VueI18n({
  locale: window.navigator.language.slice(0,2),
  fallbackLocale: 'ru',
  messages
});

Vue.use(VueRouter);
Vue.use(VueMq, {
  breakpoints: {
    md: 768,
    lg: 992,
    xl: Infinity,
  }
})

Vue.prototype.$http = Axios;

const router = new VueRouter({
  mode: 'history',
  //base: process.env.BASE_URL,
  routes
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

